

import React from 'react';

import ReactDOM from 'react-dom';

 

import KeeVue from '../base/KeeVue.js'
import FeasComponents from '../render/FeasComponents.js'

export default class FsForm extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {

				randId: this.getRandString(),


				pagination: {
					total: 0,
					rows: 10,
					page: 1,
					totalPage: 0,
				},
				sort: 'id',
				order: 'desc',
				groupby: '',
				listName: '',
				isShowGrid: false,
				pageSize: 10,
				currentPage4: 1,
				height: 500,
				hasFixedField: false,
				componentState: {
					refreshTime: 0
				},
				showType: "grid", // 是否采用grid，或card方式显示
				configWindow: null,
				dtoFields: '',
				selectedRows: [],
				isSubmitIng: false,
				extraParas: null,
				dialogConfig: null,
				display: false,
				formId: '',
				formResetData: {},
				isLoaded: false,
				currentFormData: {},
				configFormItems:null,
				isCanel:false,
				submitButton:null,
				labelPositon:"left",
			}

}

componentDidMount(){
			var that = this;
			this.registComponent();
			console.log("fs-form：this.props.component.value 值： "+this.props.component.value)
			if(this.props.component)
			{
				if(this.props.component.value) {
					this.showData(this.props.component.value);
				}
				else
					if(this.props.po  ) {
						console.log("采用po值进行渲染： ")
						this.showData(this.props.po);
					}
					else
					{
						this.showData({});
					}
			}
		}

			onCommand=(cmdName, item, po, thisForm, parentForm)=> {
				if(cmdName === "change") {
					this.checkIsCanShow(this.props.component.child);
				}
				this.$emit("command", cmdName, item, po, thisForm, parentForm);
			}
			updateEditable=(componentArray,editable)=>
			{
				if(componentArray)
				{
					for(var i=0;i<componentArray.length;i++)
					{
						componentArray[i].editable = editable;
						if(componentArray[i].child&&componentArray[i].child.length>0)
						{
							this.updateEditable(componentArray[i].child);
						}
					}
				}
			}
			showForm=(targetId,data)=>{
				var that = this;
				console.log("开始渲染页面：targetId:"+targetId)
				if(this.isNotBlank(targetId))
				{
					console.log("准备请求:"+targetId)
					this.doRequest("/keeForm/getByTargetId?targetId=" + targetId, function(ret) {
						console.log("收到请求")
					console.log(JSON.stringify(ret));
					if(ret   ) {
						var form = ret;
						if(this.isNotBlank(form.formConfigJson)) {
							var formConfig = JSON.parse(form.formConfigJson);
							that.initPageComponent([formConfig],that.component.viewName);
							console.log("表单配置："+JSON.stringify(formConfig));
							for(var n = 0;n<formConfig.child.length;n++)
							{
								formConfig.child[n].style["margin"]="5px 0px";
							}
							if(formConfig.cp.labelPosition&&formConfig.cp.labelPosition!=='')
							{
								that.labelPositon = formConfig.cp.labelPosition;
							}
							console.log("that.labelPositon ："+that.labelPositon );
							that.sendViewEvent("beforeShowForm",formConfig["child"],data);
							this.setVueAttr(that.component,"child",formConfig["child"]);
							if(that.component.editable===false||that.component.cp.editable===false)
							{
								that.updateEditable(formConfig.child,false);
							}
							else
							{
								that.updateEditable(formConfig.child,true);
							}
							that.configFormItems = formConfig.child;
							if(data)
							{
								that.showData(data);
							}
						}
					} else {
						that.list = [];
					}
				})
				}
			}
			setDialogConfig=(config)=> {
				this.dialogConfig = config;
			}
			setDefaultValue=(componentArray, data)=> {
				console.log("设置默认值2：");
				if(componentArray ) {
					for(var i = 0; i < componentArray.length; i++) {
						var c = componentArray[i];
						if(this.isNotBlank(c.cp.field)) {
							c.value = this.getValueByAttr(data, c.cp.field);
						}
						if(c.name === 'fs-form') {} else {
							if(c.value === null || typeof c.value === "undefined" ) {
								if(c.cp.defaultValue  && c.cp.defaultValue !== '') {
									
									console.log("设置默认值："+c.cp.defaultValue);
									c.value = c.cp.defaultValue;
								}
							}
						}
						if(c.child ) {
							this.setDefaultValue(c.child, data);
						}
					}
				}
				this.refresh();
			}
			addForm=(aliasName)=> {
				if(this.props.component.cp.canAdd !== true) {} else {
					var row = {};
					console.log("this.props.component.templateForm"+JSON.stringify(this.props.component.templateForm));
					var newItem = JSON.parse(JSON.stringify(this.props.component.templateForm));
					newItem.alias = this.props.component.templateForm.alias + "" + this.getRandString();
					newItem.id = this.getRandString();
					newItem.isTemp = true;
					this.resetNewItem(newItem.child);
					newItem.value={};
					this.setDefaultValue(newItem.child, row);
					if(this.props.components)
					{
						this.props.components.push(newItem);
					}
				}
				
				this.refresh();
			}
			removeForm=(item)=> {
				console.log("收到删除表单指令："+item.alias);
				if(this.props.components)
				{
					this.props.components.remove(item);
				}
				this.refresh();
			}
			showData=(data)=> {
				
				if(!data)
				{
					data={} ;
				}
this.lastDataString=JSON.stringify(data);
				//console.log("展示表单数据："+JSON.stringify(data));
				//alert("this.props.component.cp.formCode:"+this.props.component.cp.formCode);
				this.state.formPoData = data;
				if(this.props.component.cp.formCode&&(this.props.component.child===null||this.props.component.child.length===0))
				{
					this.showForm(this.props.component.cp.formCode,data);
				}
				else
				{
					this.sendViewEvent("beforeShowForm",this.props.component.child,data);
					this.initComponentValue(this.props.component.child, data, this.thisForm, this.parentForm);
					this.checkIsCanShow(this.props.component.child);
					this.display = true;
					this.formId = data.id;
					this.formResetData = JSON.parse(JSON.stringify(data));
					this.isLoaded = true;
				}
				this.resetErrorMessage(this.props.component.child);
				this.setState(this.state);
			}
			resetForm=(data)=> {
				if(data===null)
				{
					data = {};
				}
				//alert("resetForm");
				this.showData(data);
			}
			resetErrorMessage=(componentArray)=>{
				if(componentArray ) {
					for(var i = 0; i < componentArray.length; i++) {
						var c = componentArray[i];
						c.error = false;
						c.errorMsg = "";
						this.resetErrorMessage(c.child);
					}
				}
			}
			checkIsCanShow=(componentArray)=> {
				if(componentArray ) {
					for(var i = 0; i < componentArray.length; i++) {
						var c = componentArray[i];
						this.checkIsCanShow(c.child);
					}
				}
			}
			resetNewItem=(componentChild)=>
			{
				for(var i=0;componentChild&&i<componentChild.length;i++)
				{
					componentChild[i].id=this.getRandString();
					componentChild[i].alias="cf"+this.getRandString();
					if(componentChild[i].child)
					{
						this.resetNewItem(componentChild[i].child);
					}
				}
			}
			initComponentValue=(componentArray, toShowData)=> {
				 
				
				if(componentArray ) {
					for(var i = 0; i < componentArray.length; i++) {
						var c = componentArray[i];
						if(c.isTemp === true) {
							componentArray.remove(c);
							i--;
							continue;
						}
						c.rowid = toShowData.id;
						if(c.name === 'fs-form') {
							// if(!c.templateForm &&c.isTemp !==true) {
							// 	var childForm = JSON.parse(JSON.stringify(c));
							// 	c.templateForm = childForm;
							// }
							if(this.isNotBlank(c.cp.field)) {
								c.value = this.getValueByAttr(toShowData, c.cp.field);
							}
							if(c.cp.filter) {
								c["html_" + c.cp.field] = window.KeeFormatters[c.cp.filter](this.getValueByAttr(toShowData, c.cp.field), toShowData);
							}
							this.initComponentValue(c.child, toShowData);
							
							if(c.cp.canAdd !== true) {
								// c.child = [];
								// var row = {};
								// if(this.isNotBlank(c.value)) {
								// 	var childFormData = JSON.parse(c.value);
								// 	if(childFormData.length > 0) {
								// 		row = childFormData[0];
								// 	}
								// } else {
								// }
								// var newItem = JSON.parse(JSON.stringify(c.templateForm));
								// newItem.id = this.getRandString();
								// newItem.alias = c.templateForm.alias + "" + 11;
								// newItem.isTemp = true;
								// newItem.value = row;
								// this.resetNewItem(newItem.child);
								// componentArray.insert(i, newItem);
								// i++;
								// if(newItem.child ) {
								// 	this.initComponentValue(newItem.child, row);
								// }
							} else {
								// if(this.debug !== true) {
								// 	c.visiable = false; // 原版的需要隐藏
								// 	var childFormData = [];
								// 	if(this.isNotBlank(c.value)) {
								// 		childFormData = JSON.parse(c.value);
								// 	}
								// 	if(childFormData === null || childFormData.length === 0) {
								// 		childFormData = []
								// 	}
								// 	c.child = [];
								// 	console.log("数据长度："+childFormData.length+JSON.stringify(childFormData));
								// 	for(var m = 0; m < childFormData.length; m++) {
								// 		var row = childFormData[m];
								// 		var newItem = JSON.parse(JSON.stringify(c.templateForm));
								// 		newItem.id = this.getRandString();
								// 		newItem.alias =   "childform" + this.getRandString();
								// 		newItem.value = row;
								// 		newItem.isTemp = true;
								// 		this.resetNewItem(newItem.child);
								// 		componentArray.push(newItem);
								// 		i++;
								// 		console.log("row:"+JSON.stringify(row));
								// 		if(newItem.child ) {
								// 			this.initComponentValue(newItem.child, row);
								// 		}
								// 	}
								// }
							}
						} else {
							if(this.isNotBlank(c.cp.field)) {
								if(c.name === 'fs-date') {
									var itemValue = this.getValueByAttr(toShowData, c.cp.field);
									if(itemValue ) {
										if(this.isNotBlank(c.cp.format)) {
											c.value = this.formatterDate(itemValue, c.cp.format);
										} else {
											c.value = this.formatterDate(itemValue, "yyyy-MM-dd");
										}
									}
								}
								else
								if(c.name==='fs-table')
								{
									 
									c.value = this.getValueByAttr(toShowData, c.cp.field);
									
									// if(c.value&&typeof c.value=="string")
									// {
									// 	c.value = JSON.parse(c.value);
									// }
									
									if(!c.value)
									{
										c.value=[];
									}
									
									
									if(c.value)
									{
										
										//alert(c.alias+c.rowid);
										//window.CReactMap[c.viewName].[c.alias+c.rowid].showData(c.value);
										
										// alert("chushsh table"+JSON.stringify(c.value));
										
										for(var m=0;m<c.value.length;m++)
										{
											if(c.value[m].component)
											{
												c.value[m].component.value={};
											}
										}
									}
								}
								else
								{
									c.value = this.getValueByAttr(toShowData, c.cp.field);
								}
								
								if(c.name === 'fs-table' ) {
									if(!c.value)
									{
										console.log(JSON.stringify(toShowData));
										console.log("设置值：初始化表格数据" );
									   	this.setVueAttr(toShowData,c.cp.field,[]);
									}
									
									
								}
								if((typeof c.value=='undefined'||c.value===null)&&c.name !== 'fs-switch') {
									if(c.cp.defaultValue  && c.cp.defaultValue !== '') {
										c.value = c.cp.defaultValue;
										if(c.cp.field&&c.cp.field.indexOf("style.")!==0)
										{
											this.setVueAttr(toShowData,c.cp.field, c.value );
										}
									}
								}
								//console.log(c.cp.field+" c.value:"+JSON.stringify(c.value));
								if(c.name === 'fs-switch') {
									if("1"===c.value||c.value==true||c.value=="true")
									{
										c.value =true;
									}
									else
									{
										c.value = false;
									}
									
									this.setVueAttr(toShowData,c.cp.field, c.value );
									
								 
									//console.log("设置fs-switch的值："+c.value);
							 
								}
								
								// if(c.value===null)
								// {
								// 	c.value="";
								// 	this.setVueAttr(toShowData,c.cp.field,'');
								// }
								//console.log(c.cp.field+" c.value:"+JSON.stringify(c.value));
								//console.log("设置值：" + c.cp.field + " ：：" + c.value);
							}
							if(c.child &&c.name !== 'fs-table') {
								this.initComponentValue(c.child, toShowData);
							}
						}
					}
				}
			}
			getData=()=> {
				var data = {};
				this.fillSubmitData(this.props.component.child, data);
				return data;
			}
			fillSubmitData=(componentArray, postData)=> {
				if(componentArray ) {
					for(var i = 0; i < componentArray.length; i++) {
						var c = componentArray[i];
						
						console.log("组件："+c.alias+":::"+c.value);
						if(c.name === "fs-table") {
							
							console.log("开始获取form的值:"+c.alias+c.rowid)
							 
							var table = window.CReactMap[c.viewName][c.alias+c.rowid];
							if(table)
							{
								//alert("row fangshi ")
								postData[c.cp.field] =  JSON.stringify((table.getGridFormData()));
							}
							else
							{
								table = window.CReactMap[c.viewName][c.alias];
								if(table)
								{
									//alert("alias")
									postData[c.cp.field] = JSON.stringify( (table.getGridFormData()));
								}
							}
							
						} else
						if(c.name === "fs-html-editor" || c.name === "fs-code-editor") {
							var vueEditor = window.CReactMap[c.viewName][c.alias];
							postData[c.cp.field] = vueEditor.getData();
						} else
						if(c.name === "fs-form") {
							if(c.child  && c.visiable !== false) {
								var childFormData = {};
								this.fillSubmitData(c.child, childFormData);
								{
									var arr = [];
									if(postData[c.cp.field] ) {
										arr = JSON.parse(postData[c.cp.field]);
									}
									arr.push(childFormData);
									postData[c.cp.field] = JSON.stringify(arr);
								}
							}
						} else {
							
							if(window.isReport&&c.type=='form')
							{ 
								if(!c.cp.field)
								{
									c.cp.field = c.alias;
								} 
							}
							
							var formItem = window.CReactMap[c.viewName][c.alias];
							if(formItem  && typeof formItem.getData === "function") {
								postData[c.cp.field] = formItem.getData();
							} else
							if(this.isNotBlank(c.cp.field)) {
								postData[c.cp.field] = c.value;
							}
							
							
							
							if(c.child ) {
								this.fillSubmitData(c.child, postData);
							}
						}
						if(c.name === "fs-date" && c.cp.subType === "dateRange") {
							 
							var rangefield = c.cp.field;
							if(this.isNotBlank(c.value)) {
								var dates = c.value;
								postData[rangefield] = null;
								if(this.isNotBlank(dates[0])) {
									postData[rangefield.replace("_BTW_", "_GTE_")] = dates[0];
								}
								if(this.isNotBlank(dates[1])) {
									postData[rangefield.replace("_BTW_", "_LTE_")] = dates[1] + " 23:59:59";
								}
							}
						}
					}
				}
			}
			validValue=(item)=> {
				var error = false;
				var errorMsg = "";
				if(item.type === "dateRange") {
					if(item.cp.required  && item.cp.required === true) {
						var str = JSON.stringify(item.value);
						if(str.length < 26 || str.indexOf("N") !== -1) {
							error = true;
							errorMsg = "必填项";
						}
					}
				} else {
					if(item.cp.required  && item.cp.required === true) {
						if(!item.value||item.value===[]||item.value=="[]") {
							error = true;
							errorMsg = "必填项";
						}
					}
				}
				if(item.cp.format  && item.cp.format !== "") {
					if(item.cp.format === "text") {
					}
					if(item.cp.format === "email" && item.value  && item.value !== "" && this.isEmail(item.value) === false) {
						error = true;
						errorMsg = "邮箱格式错误";
					}
					if(item.cp.format === "phone" && item.value  && item.value !== "" && this.isPhone(item.value) === false) {
						error = true;
						errorMsg = "电话格式错误";
					}
					if(item.cp.format === "tel" && item.value  && item.value !== "" && this.isTel(item.value) === false) {
						error = true;
						errorMsg = "手机号格式错误";
					}
					if(item.cp.format === "idcard" && item.value  && item.value !== "" && this.isIdCard(item.value) === false) {
						error = true;
						errorMsg = "身份证格式错误";
					}
					if(item.cp.format === "ip" && item.value  && item.value !== "" && this.isIp(item.value) === false) {
						error = true;
						errorMsg = "IP格式错误";
					}
					if(item.cp.format === "number" )
					{
						if(item.cp.decimal){
							if(item.value  && item.value !== "" && this.isNumLen(item.value, item.cp.decimal) === false){
								console.log(222);
								error = true;
								errorMsg = "不是数字或长度不符";
							} else {
								return item.value;
							}
						} else {
							if(item.value  && item.value !== "" && this.isNumber(item.value) === false) {
								console.log(111);
								error = true;
								errorMsg = "只能输入数字";
							}
							else
							{
								item.value=parseInt(item.value)
							}
						}
					}
					if(item.cp.format === "float" && item.value  && item.value !== "" && this.isFloat(item.value) === false) {
						error = true;
						errorMsg = "只能输入小数";
					}
					if(item.cp.format === "int" && item.value  && item.value !== "" && this.isInt(item.value) === false) {
						error = true;
						errorMsg = "只能输入正整数";
					}
				}
				if(item.cp.minLength  && item.cp.minLength !== "") {
					if(item.value  && item.value.length < parseInt(item.cp.minLength)) {
						error = true;
						errorMsg += "输入长度最小为" + item.cp.minLength + "个字符";
					}
				}
				if(item.cp.maxLength  && item.cp.maxLength !== "") {
					if(item.value  && item.value.length > parseInt(item.cp.maxLength)) {
						error = true;
						errorMsg += "输入长度最大为" + item.cp.maxLength + "个字符";
					}
				}
				if(item.cp.format === 'number' || item.cp.format === 'float' || item.cp.format === 'int') {
					// if(this.isNotBlank(item.cp.min)) {
					// 	if(item.value  && parseInt(item.value) < parseInt(item.cp.min)) {
					// 		error = true;
					// 		errorMsg += "不能小于值" + item.cp.min + "";
					// 	}
					// }
					// if(this.isNotBlank(item.cp.max)) {
					// 	if(item.value  && parseInt(item.value) > parseInt(item.cp.max)) {
					// 		error = true;
					// 		errorMsg += "不能大于值" + item.cp.max + "";
					// 	}
					// }
				}
				item.error = error;
				item.errorMsg = errorMsg;
			}
			validComponents=(componentArray, errorComponents)=> {
				if(componentArray ) {
					for(var i = 0; i < componentArray.length; i++) {
						var c = componentArray[i];
						if(c.visiable === false) {
							continue;
						}
						if(c.name==='fs-table')
						{
							var viewName = this.props.component.viewName;
							var errorItems = window.CReactMap[viewName][c.alias].validTableComponents();
							if(errorItems)
							{
							   for(var a=0;a<errorItems.length;a++)
							   {
							   	 errorComponents.push(errorItems[a]);
							   }
							}
							continue;
						}
						//if(c.error !==true)
						{
						 	this.validValue(c);
						}
						if(c.error === true) {
							console.log(c.alias+"校验错误11！")
							errorComponents.push(c);
						}
						if(c.error!==true&& c.type !== 'form' )
						{
							var viewName = this.props.component.viewName;
							if(typeof window.CReactMap[viewName][c.alias]!=="undefined" && window.CReactMap[viewName][c.alias]  && typeof window.CReactMap[viewName][c.alias].valueChange === "function")
							{
								window.CReactMap[viewName][c.alias].valueChange(c);
							}
							if(c.error === true) {
								console.log(c.alias+"校验错误！")
								errorComponents.push(c);
							}
						}
						if(c.child ) {
							this.validComponents(c.child, errorComponents);
						}
					}
				}
			}
			formChanged=(ret)=> {
				this.$emit("changed", ret);
			}
			
			checkForm=()=>{
				var errorComponents = [];
				 
				this.resetErrorMessage(this.props.component.child);
				
				
				this.validComponents(this.props.component.child, errorComponents);
				if(errorComponents.length !== 0) {
					this.refresh();
					
					let msg = "";
					
					for(let t=0;t<errorComponents.length;t++)
					{
						let item = errorComponents[t];
						if(item.errorMsg=='必填项')
						{
							msg="请填写必填项"
						}
					}
					
					if(msg=="")
					{
						msg = errorComponents[0].errorMsg;
					}
					
					this.showErrorMessage(msg)
					return false;
				}
				
				return true;
			}
			
			submit=(callback)=> {
				this.submitForm(callback);
			}
			cancel=()=>{
				this.isCanel = true;
			}
			submitForm=(callback)=> {

				 
				 
				var that = this;
				this.isSubmitIng = true;
				var uploadFileIds = "";
				var isHasErrorField = false;
				this.isCanel = false;
				var errorComponents = [];
				this.validComponents(this.props.component.child, errorComponents);
				if(errorComponents.length !== 0) {
					//this.showErrorMessage("信息填写有误，请修改")
					
					let msg = "";
					
					for(let t=0;t<errorComponents.length;t++)
					{
						let item = errorComponents[t];
						if(item.errorMsg=='必填项')
						{
							msg="请填写必填项"
						}
					}
					
					if(msg=="")
					{
						msg = errorComponents[0].errorMsg;
					}
					
					this.showErrorMessage(msg);
					
					this.refresh();
					
					return false;
				}
				var postData = {
					id: this.formId,
				};
				if(this.extraParas ) {
					for(var p in this.extraParas) {
						postData[p] = this.extraParas[p];
					}
				}
				this.fillSubmitData(this.props.component.child, postData);
				if(that.debug === true) {
					this.showErrorMessage("配置模式下不能提交数据");
					return;
				}
				var toSubmitFields = "";
				for(var p in postData) {
					if(toSubmitFields !== "") {
						toSubmitFields += ",";
					}
					toSubmitFields += p;
				}
				
				//alert(JSON.stringify(postData));
				
				postData["toSubmitFields"] = toSubmitFields;
				
				let  formSubmitUrl = that.component.cp.url;
				
				if(!formSubmitUrl)
				{
					if(this.props.keePage&&this.props.keePage.config&&this.props.keePage.config.entity)
					{
						formSubmitUrl = "/"+this.props.keePage.config.entity+"/save";
					}
				}
				
				if(this.isNotBlank(formSubmitUrl)) {
					that.sendViewEvent("beforeSubmit",postData);
					if(!that.isCanel)
					{
						if(that.submitButton)
						{
							that.submitButton.disable();
						}
						this.doRequest(formSubmitUrl, function(ret) {
							if(that.submitButton)
							{
								that.submitButton.enable();
							}
							that.sendViewEvent("afterSubmit",ret,postData,that);
						if(typeof callback === 'function' && callback ) {
							callback(ret);
							that.$emit("command", "close");
							return;
						}
						if(ret.success  && ret.success === true) {
							that.isSubmitIng = false;
							if(that.dialogConfig  && typeof that.dialogConfig.onChanged === "function") {
								 
								that.dialogConfig.onChanged(ret, that);
							} else {
								ret.data = postData;
								//that.$emit("changed", ret);
								that.sendViewEvent("changed");
								that.$emit("command", "close");
							}
						} else {
							this.showErrorMessage(ret.message);
							that.isSubmitIng = false;
						}
					}, postData);
					}
				} else {
					var ret = {
					};
					ret.data = postData;
					if(that.dialogConfig  && typeof that.dialogConfig.onChanged === "function") {
								that.dialogConfig.onChanged(ret, that);
					}
					else
					{
						that.$emit("changed", ret);
						that.sendViewEvent("changed");
					}
				}
			}

		componentWillReceiveProps(nextProps){
						  
						  var that = this;
						  
						  if(nextProps.po&&this.lastDataString!==JSON.stringify(nextProps.po))
						  {
							   that.showData(nextProps.po);
						  }
 
  
						  // if(JSON.stringify(this.props.po)!==JSON.stringify(nextProps.po))
						  // {
							   
							 //    that.showData(nextProps.po);
						  // }
						  
						 
						  
						  		 

		}

	initComponentLabelPosition=(componentArray, labelPosition)=> {
				for(var i = 0; i < componentArray.length; i++) {
					var c = componentArray[i];
					
					if(!c.cp.labelPosition)
					{
						c.cp.labelPosition = labelPosition;
					} 
					if( c.child  && c.child.length > 0) {
						this.initComponentLabelPosition(c.child, labelPosition);
					}
				}
			}
			
	checkParentForm = (cs)=>{
		
		if(cs)
		{
			for(let i=0;i<cs.length;i++)
			{
				if(cs[i].name=='fs-form'&&cs[i].id!=this.props.component.id)
				{
					this.hasParent = true;
					return ;
				}
				if(cs[i].child)
				{
					this.checkParentForm(cs[i].child);
				}
				
			}
		}
		
	}


  render(){
	  
	  var className="el-form"+"el-form--label-"+this.props.component.cp.labelPosition;
	 // console.log("表单里面：",this.props.component);
	 var style = JSON.parse(JSON.stringify(this.props.component.style));
	 style.height='100%';
	 style.minHeight='10px';
	 
	 // 看看你form有没有上级？
	 
	 if(this.props.component&&this.props.component.viewName&&window.CReactMap[this.props.component.viewName])
	 {
		this.checkParentForm(window.CReactMap[this.props.component.viewName].components);
	 }
	 
	 
	//alert("this.hasParent:"+this.hasParent);
	
	
	 
	 //  设置子组件的 labelPosition
	 this.initComponentLabelPosition(this.props.component.child,this.props.component.cp.labelPosition);
  return <div  id={this.state.randId} style={{padding:(window.isReport?'8px':'')}}>
 
 {
	 this.hasParent?(
	this.state.configFormItems? <div className={`el-row`} > <div className={`${className}` }    >
	{
		this.props.component.child&&this.props.component.child.length>0?<FeasComponents components={this.props.component.child}
	editable={this.props.component.cp.editable?true:false } 
	keePage={this.props.keePage} 
	thisForm={this.props.component} 
	parentForm={this.props.component} 
	debug={this.props.debug} 
	po={this.props.po?this.props.po:this.state.formPoData} 
	onChanged={this.formChanged} 
	onCommand={this.onCommand} >
	    </FeasComponents>:(window.isReport&&this.props.debug&&<div style={{width:'100%',textAlign:'center',paddingTop:'200px',color:'#666666'}}>从左侧“组件”中拖拽控件到此区域</div>)
	}
	
	</div>
	</div>
	:
	<div className={`el-row`} >
	<div className={`${className}` } onSubmit={()=>{return false}}  >
	{
		this.props.component.child&&this.props.component.child.length>0? <FeasComponents   components={this.props.component.child} editable={this.props.component.cp.editable?true:false } thisForm={this.props.component} parentForm={this.props.component} po={this.props.po?this.props.po:this.state.formPoData} debug={this.props.debug} 
		onchanged={this.formChanged}
		onCommand={this.onCommand} >
	    </FeasComponents>:(window.isReport&&this.props.debug&&<div style={{width:'100%',textAlign:'center',paddingTop:'200px',color:'#666666'}}>从左侧“组件”中拖拽控件到此区域</div>)
	
	}</div>
	</div>
):(

	this.state.configFormItems? <div className={`el-row`} > <form className={`${className}` } onSubmit={()=>{return false}}   >
	{
		this.props.component.child&&this.props.component.child.length>0?<FeasComponents components={this.props.component.child}
	editable={this.props.component.cp.editable?true:false } 
	keePage={this.props.keePage} 
	thisForm={this.props.component} 
	parentForm={this.props.component} 
	debug={this.props.debug} 
	po={this.props.po?this.props.po:this.state.formPoData} 
	onChanged={this.formChanged} 
	onCommand={this.onCommand} >
	    </FeasComponents>:(window.isReport&&this.props.debug&&<div style={{width:'100%',textAlign:'center',paddingTop:'200px',color:'#666666'}}>从左侧“组件”中拖拽控件到此区域</div>)
	}
	
	</form>
	</div>
	:
	<div className={`el-row`} >
	<form className={`${className}` } onSubmit={()=>{return false}}  >
	{
		this.props.component.child&&this.props.component.child.length>0? <FeasComponents 
		  components={this.props.component.child} editable={this.props.component.cp.editable?true:false }
		   thisForm={this.props.component} parentForm={this.props.component} 
		   
		   po={this.props.po?this.props.po:this.state.formPoData} debug={this.props.debug} 
		onchanged={this.formChanged}
		onCommand={this.onCommand} >
	    </FeasComponents>:(window.isReport&&this.props.debug&&<div style={{width:'100%',textAlign:'center',paddingTop:'200px',color:'#666666'}}>从左侧“组件”中拖拽控件到此区域</div>)
	
	}</form>
	</div>

)
 }




</div>
  }
 }
